<template>
  <div>
    <gSwiper :arr="arr2" :maxH="'inherit'"></gSwiper>
    <div class="register">

      <Row :gutter="10" class="top">
        <Col span="12">
        <div class="title">中国国际焙烤展 展商报名</div>
        </Col>
        <Col span="12" class="f-tar">
        <!-- <Button shape="circle" style="border-color:#b10042;color:#b10042;">中文</Button> -->
        <Button shape="circle" style="border-color:#b10042;color:#b10042;"
          @click="$router.push(`/ex-register-en/register`)">English</Button>
        </Col>
      </Row>
      <registerForm ref="registerForm"></registerForm>
      <registerEntrance ref="registerEntrance"></registerEntrance>

      <div class="f-tac submit-btn">
        <Button type="primary" size="large" @click="handleSubmit" :loading="loading">确认以上信息，并提交展位申请</Button>
      </div>

      <div class="tip-info">
        <p>注：</p>
        <p>1. 展会主办单位有修改、调整展位图的权利。</p>
        <p>2. 此表仅为展位预定时使用，非正式参展合同。正式参展以展位合同为准。</p>
        <p>3.特别提醒：每家展商在签署展位合同的时候，还需同时签署为期1年的B2B线上服务，目前年费优惠价2000元（原价5000元），敬请知悉。</p>
      </div>
    </div>
  </div>
</template>
’
<script>
import { mapActions } from "vuex";
import registerForm from "./components/register-form.vue";
import registerEntrance from "./components/register-entrance.vue";
import gSwiper from "@components/gSwiper/gSwiper2.vue";
import axios from "axios";
import { MD5 } from 'crypto-js';
import config from '@assets/config.json';
export default {
  name: 'register',
  components: {
    registerForm,
    registerEntrance, gSwiper
  },
  props: {},
  data() {
    return {
      loading: false,
      tokens: '',
      // arr2: [{ id: 1, path: "https://obs.bakerychina.com/cloudExhibition/imgs/202410/e8d24f1054da4185ae0d8fa3f46ab100.jpg" }],
      arr2: [{ id: 1, path: "https://obs.bakerychina.com/imgs/202512/23330eea0379477fa122bc339f375825.jpg" }],
    };
  },
  watch: {},
  computed: {},
  methods: {
    ...mapActions({
      getApplyCompanyRoastCreate: 'registerdModule/getApplyCompanyRoastCreate', // 新增展会接口
    }),
    // 获取随机6位字符串
    getRandomString(length) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return result;
    },
    // 获取时间
    getUTCTimestampInSeconds() {
      const now = new Date(); // 获取当前时间
      const utcTimestampInMilliseconds = now.getTime(); // 获取当前时间的毫秒时间戳
      const utcTimestampInSeconds = Math.floor(utcTimestampInMilliseconds / 1000); // 转换为秒
      return utcTimestampInSeconds;
    },
    // 获取token
    async token(opt) {
      try {
        const params = new URLSearchParams();
        params.append('client_id', 'MYDev-YPVMbMBCaNCxMZlxjdnvEmZLDacXec');
        params.append('client_secret', 'pdLudeaW4OLZiqt8U7hXoqI5W7BxQujBSqXG');
        params.append('grant_type', 'client_credentials');
        params.append('scope', 'open_api');

        const response = await axios.post('https://api-ecrm.reed-sinopharm.com/connect/token', params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          }
        });
        console.log(response, 'responseresponseresponse')
        if (response.data.access_token) {
          this.tokens = response.data.access_token;
          this.myOtherCreate(opt)
        }
      } catch (error) {
        console.error('Error:', error);
      }

      // try {
      //   const params = new URLSearchParams();
      //   params.append('client_id', 'MYDev-G1a5arUpmsph159So8dEu6zZxBqJDs');
      //   params.append('client_secret', 'gykLH9zpRHGgMoGgFDvxqZnIBEkrTnWT4adt');
      //   params.append('grant_type', 'client_credentials');
      //   params.append('scope', 'open_api');

      //   const response = await axios.post('https://ecapi.expo2345.com/connect/token', params, {
      //     headers: {
      //       'Content-Type': 'application/x-www-form-urlencoded',
      //     }
      //   });
      //   if (response.data.access_token) {
      //     this.tokens = response.data.access_token;
      //     this.myOtherCreate(opt)
      //   }
      // } catch (error) {
      //   console.error('Error:', error);
      // }
    },
    async handleSubmit() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);

      let res = await this.$refs.registerForm.handleSubmit();
      this.loading = false;
      if (!res.valid) return;
      let res2 = await this.$refs.registerEntrance.validHandle();
      if (!res2.valid) return;
      console.log('registerForm', res);
      console.log('registerEntrance', res2);
      let lists = [];
      if (res2.ApplyCompanyOrderNewDto) {
        lists.push({
          ...res2.ApplyCompanyOrderNewDto
        });
      }
      if (res2.ApplyCompanyOrderNewDto2) {
        lists.push({
          ...res2.ApplyCompanyOrderNewDto2
        });
      }
      if (res2.ApplyCompanyOrderNewDto3) {
        lists.push({
          ...res2.ApplyCompanyOrderNewDto3
        });
      }
      let opt = {
        newCompany: { ...res2.common, ...res.form, },
        lists: lists,
        reportType: 'cn'
      };
      let exname = '';
      res2.exhibition.forEach((c, index) => {
        exname += c.name;
        if (res2.exhibition.length !== index + 1) {
          exname += ','
        }
      });
      // this.token(opt)

      let bool = await this.getApplyCompanyRoastCreate(opt);
      if (bool && bool.successed) {
        let query = 'company=' + encodeURI(res.form.companyName) + '&exname=' + encodeURI(exname);
        this.$router.push(`/ex-register/register-result?${query}`);
      } else {
        let errTxt = bool.msg || bool.info || "提交失败，请重新尝试！";
        if (bool.errors && bool.errors[0] && bool.errors[0].description) {
          errTxt = bool.errors[0].description;
        }
        this.$Message.error(errTxt);
      }

    },
    // 提交到慕渊云
    async myOtherCreate(opt) {

      const xAdprvClientId = 'MYDev-YPVMbMBCaNCxMZlxjdnvEmZLDacXec'
      const xAdprvClientSecret = 'j7hua3qeZhF1iriZHu5OlXztCz1xrV7QCfAKHxrYt9w='
      // const xAdprvClientId = 'MYDev-G1a5arUpmsph159So8dEu6zZxBqJDs'
      // const xAdprvClientSecret = '2Nt8sOQHkVjG/jOCA6pUEvhAm1ynag7/cWwx+y8ysXw='
      const noncestr = this.getRandomString(6)
      const timer = this.getUTCTimestampInSeconds()

      const sign = `x-adprv-client-id=${xAdprvClientId}\\\\x-adprv-client-secret=${xAdprvClientSecret}\\\\x-adprv-noncestr=${noncestr}\\\\x-adprv-timestamp=${timer}`
      const signMd5 = MD5(sign).toString();
      // 发送请求到慕渊云
      // const query = `#graphql
      //   mutation($command: IntentionBakeryCreateCommandInput!){
      //     intention{
      //       bakeryCreate(command:$command)
      //     }
      //   }
      // `;
      const address = {
        country: opt.newCompany.country,
        province: opt.newCompany.province,
        city: opt.newCompany.city,
        county: '',
        details: opt.newCompany.address,
        postcode: opt.newCompany.postcode
      }
      const contacts = [{
        "kind": '展会联系人',
        "name": opt.newCompany.linkMan,
        "jobTitle": opt.newCompany.linkTitle,
        "phoneNumber": opt.newCompany.linkMob,
        "email": opt.newCompany.linkEmail,
        "tel": {
          countryCode: '',
          areaCode: opt.newCompany.linkCode || '',
          code: opt.newCompany.linkTelephone || '',
          subcode: ''
        },
        "qq": opt.newCompany.linkQQ,
        "weChat": opt.newCompany.linkWeChat,
      }, {
        "kind": '市场部负责人',
        "name": opt.newCompany.leader,
        "jobTitle": opt.newCompany.leaderTitle,
        "phoneNumber": opt.newCompany.leaderMob,
        "email": opt.newCompany.leaderEmail,
        "tel": {
          countryCode: '',
          areaCode: opt.newCompany.LeaderCode || '',
          code: opt.newCompany.leaderTelephone || '',
          subcode: ''
        },
        "qq": opt.newCompany.leaderQQ,
        "weChat": opt.newCompany.leaderWeChat,
      }]
      const deliveryAddress = {
        country: opt.newCompany.invoiceMalingCountry,
        province: opt.newCompany.invoiceMalingProvince,
        city: opt.newCompany.invoiceMalingCity,
        county: '',
        details: opt.newCompany.invoiceMalingAdress,
        postcode: opt.newCompany.invoiceMalingCode,
      }
      const booths = []
      opt.lists.forEach((value, index) => {
        booths.push({
          "exhibitionId": value.exhibitionId == 'c221ade0-5a95-45c6-b5e0-a935348c2a5e' ? 'be113c25-2d4f-d2e4-abe2-3a2126e8f0a5' : 'fe7736bf-25e1-a654-9e9b-3a16183f2138',
          "kind": value.ApplyBoothOrder.boothType == '光地' ? '特装' : '标展',
          "name": value.areaName,
          "num": value.ApplyBoothOrder.boothType == '光地' ? value.showArea : parseFloat((value.showArea / 9).toFixed(2)),
          "hall": value.exHall
        })
        // if (index == 0) {
        //   booths.push({
        //     "exhibitionId": "6b397ab4-e70a-24fd-637e-3a0ec8f94574",
        //     "kind": value.ApplyBoothOrder.boothType == '光地' ? '特装' : '标展',
        //     "name": value.areaName,
        //     "num": value.showArea,
        //     "hall": value.exHall
        //   })
        // }
      })
      let currentId = opt.lists[0].exhibitionId == 'c221ade0-5a95-45c6-b5e0-a935348c2a5e' ? 'be113c25-2d4f-d2e4-abe2-3a2126e8f0a5' : 'fe7736bf-25e1-a654-9e9b-3a16183f2138'
      const response = await axios
        .post(
          `${config.apiMy.reqApi}/api/v1/intention/CMEFOtherCreate`,
          // `https://ecapi.expo2345.com/api/v1/intention/CMEFOtherCreate`,
          {
            "name": opt.newCompany.companyName,
            "nameEn": opt.newCompany.companyNameEn,
            "shortName": opt.newCompany.companyNameShort,
            "shortNameEn": '',
            "unicode": opt.newCompany.unifiedCode,
            "address": address,
            "addressEn": "",
            "website": opt.newCompany.website,
            "attachmentBusinessLicenseImgUrl": opt.newCompany.imgBusinessLicense ? JSON.parse(opt.newCompany.imgBusinessLicense).url : '',
            "fax": "",
            "invoiceDto": {
              "lookUp": opt.newCompany.invoiceTitle,
              "taxNumber": opt.newCompany.invoiceCode,
              "address": opt.newCompany.invoiceAddress,
              "bank": opt.newCompany.invoiceBank,
              "bankAccount": opt.newCompany.invoiceBankAccount,
              "tel": opt.newCompany.invoiceTelephone,
            },
            "invoiceRemark": '',
            "attachmentLogoUrl": '',
            "contacts": contacts,
            "booths": booths,
            "specialFileds": {
              "parentName": opt.newCompany.isBelongChild ? opt.newCompany.parentCompanyName : '',
              "invoiceType": opt.newCompany.invoiceType,
              "invoiceAddress": JSON.stringify(deliveryAddress),
              "invoiceReveiver": opt.newCompany.invoiceRecivePerson,
              "invoiceReveiverTel": opt.newCompany.invoiceReciveTel,
              "joinProductType": opt.newCompany.productName,
              "advertPlan": opt.newCompany.planAd,
            },
            "projectId": '46659337-5542-bb40-74a9-3a14d23a7c6e',
            "exhibitionId": currentId
            // "projectId": "b2fa0915-254a-5a02-40ad-3a0cef45f376",
            // "exhibitionId": "6b397ab4-e70a-24fd-637e-3a0ec8f94574"
          },
          {
            headers: {
              'x-exhibition-id': currentId,
              'x-project-id': '46659337-5542-bb40-74a9-3a14d23a7c6e',
              // 'x-exhibition-id': '6b397ab4-e70a-24fd-637e-3a0ec8f94574',
              // 'x-project-id': 'b2fa0915-254a-5a02-40ad-3a0cef45f376',
              'content-type': 'application/json',
              'x-adprv-noncestr': noncestr,
              'x-adprv-timestamp': timer,
              'x-adprv-sign': signMd5,
              'Authorization': 'Bearer ' + this.tokens
            }
          }
        )

      // axios
      //   .post(
      //     `https://api-ecrm.reed-sinopharm.com/graphql`,
      //     {
      //       query: query,

      //       variables: {
      //         command: {
      //           "name": opt.newCompany.companyName,
      //           "nameEn": opt.newCompany.companyNameEn,
      //           "shortName": opt.newCompany.companyNameShort,
      //           "shortNameEn": '',
      //           "unicode": opt.newCompany.unifiedCode,
      //           "address": JSON.stringify(address),
      //           "address": {
      //             "Postcode": opt.newCompany.invoiceMalingCode
      //           },
      //           "addressEn": "",
      //           "tel": "",
      //           "website": opt.newCompany.website,
      //           "businessLicenseImgUrl": opt.newCompany.imgBusinessLicense,
      //           "fax": "",
      //           "invoiceLookUp": opt.newCompany.invoiceTitle,
      //           "invoiceTaxNumber": opt.newCompany.invoiceCode,
      //           "invoiceAddress": opt.newCompany.invoiceAddress,
      //           "invoiceTel": opt.newCompany.invoiceTelephone,
      //           "invoiceBank": opt.newCompany.invoiceBank,
      //           "invoiceBankAccount": opt.newCompany.invoiceBankAccount,
      //           "invoiceRemark": '',
      //           // "DeliverySurename": opt.newCompany.invoiceRecivePerson,
      //           // "DeliveryAddress": JSON.stringify(deliveryAddress),
      //           // "DeliveryAddress.Postcode": opt.newCompany.invoiceMalingCode,
      //           // "DeliveryTel": opt.newCompany.invoiceReciveTel,
      //           "attachmentLogoUrl": '',
      //           "contacts": JSON.stringify(contacts),
      //           "booths": JSON.stringify(booths),
      //           "parentName": opt.newCompany.isBelongChild ? opt.newCompany.parentCompanyName : '',
      //           "invoiceType": opt.newCompany.invoiceType,
      //           "invoiceAddress": deliveryAddress,
      //           "invoiceReveiver": opt.newCompany.invoiceRecivePerson,
      //           "invoiceReveiverTel": opt.newCompany.invoiceReciveTel,
      //           "joinProductType": opt.newCompany.productName,
      //           "advertPlan": opt.newCompany.planAd,
      //           "projectId": "46659337-5542-bb40-74a9-3a14d23a7c6e",
      //           "exhibitionId": "6b397ab4-e70a-24fd-637e-3a0ec8f94574"

      //         }
      //       }
      //     },
      //     {
      //       headers: {
      //         'x-exhibition-id': '6b397ab4-e70a-24fd-637e-3a0ec8f94574',
      //         'x-project-id': '46659337-5542-bb40-74a9-3a14d23a7c6e',
      //         'content-type': 'application/json',

      //       }
      //     }
      //   )
      //   .then(({ data }) => {
      //     console.log(data);
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
  },

  created() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.$router.push(`/ex-register/register-mobile`);
    }
  },
  mounted() { }
}

</script>

<style lang="scss" scoped>
.register {
  max-width: 1200px;
  margin: 0 auto;

  .top {
    padding: 29px 0 40px;
  }

  .title {
    font-size: 30px;
    color: #333;
    font-weight: bold;
  }
}

.submit-btn {
  margin-top: 50px;
  text-align: center;

  button {
    padding: 0 46px;
    height: 48px;
    background-color: #b10042;
    font-size: 16px;
    border-color: #b10042;
    margin-bottom: 80px;
  }
}

.tip-info {
  width: 1200px;
  margin: 0 auto 116px;

  p {
    font-size: 12px;
    color: #333;
    margin-bottom: 4px;
  }
}
</style>
